<template>
  <div class="card card-main mb-2">
    <div class="card-header d-flex align-content-center justify-content-between">
      <button v-if="showBackBtn" type="button" class="btn btn-sm btn-back btn-with-icon" data-testid="btn-go-back" @click="goBack">
        <span class="icon icon-arrow"></span>{{ $t('button.back') }}
      </button>
      <slot name="action"></slot>
      <h1 class="card-header__title" data-testid="h1-title-card">
        <slot name="title"></slot>
      </h1>
      <slot name="headerRight"></slot>
    </div>
    <div :class="{ 'card-body': needIndentContent }">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseContentBlock',
  props: {
    backName: {
      type: String,
      required: false
    },
    needBack: {
      type: Boolean,
      required: false,
      default: true
    },
    needIndentContent: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    hasRightsToBack: false
  }),
  mounted() {
    if (this.needBack) {
      this.checkRightsToBack()
    }
  },
  computed: {
    hasState() {
      return window.history.state !== null
    },
    hasBack() {
      return this.backName && this.hasRightsToBack
    },
    showBackBtn() {
      return this.needBack && (this.hasState || this.hasBack)
    }
  },
  methods: {
    goBack() {
      if (this.hasState) {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
      } else if (this.hasBack) {
        this.$router.push({ name: this.backName })
      }
    },
    checkRightsToBack() {
      if (!this.backName) {
        return
      }
      let route = this.$router.options.routes.filter(route => route.name === this.backName)[0]
      if (!route.meta || !route.meta.roles) {
        this.hasRightsToBack = true
      }
      this.$store
        .dispatch('HAS_RIGHTS', route.meta.roles)
        .then(() => {
          this.hasRightsToBack = true
        })
        .catch(() => {
          this.hasRightsToBack = false
        })
    }
  }
}
</script>
